import z from 'zod'

export const BankAccountSchema = z.object({
  id: z.number(),
  status: z.number(),
  name: z.string(),
  mid: z.string().optional(),
  v2_locations_processors_id: z.number(),
  created_by: z.number().nullable(),
  created_at: z.string().nullable(),
})

export const PaginatedProgramBankAccountsListSchema = z.object({
  current_page: z.number(),
  data: z.array(BankAccountSchema),
  first_page_url: z.string(),
  from: z.number().nullable(),
  last_page: z.number(),
  last_page_url: z.string(),
  links: z.array(
    z.object({
      url: z.string().nullable(),
      label: z.string(),
      active: z.boolean(),
    })
  ),
  next_page_url: z.string().nullable(),
  path: z.string(),
  per_page: z.number(),
  prev_page_url: z.string().nullable(),
  to: z.number().nullable(),
  total: z.number(),
})

export const createBankAccountRequestSchema = z.object({
  program_id: z.number(),
  name: z.string().min(1),
  v2_locations_processors_id: z.number(),
  status: z.union([z.literal(0), z.literal(1)]),
})

export const updateBankAccountRequestSchema = z.object({
  id: z.number(),
  program_id: z.number(),
  name: z.string().min(1),
  v2_locations_processors_id: z.number(),
  status: z.union([z.literal(0), z.literal(1)]),
})

export const ProcessorSchema = z.object({
  id: z.number(),
  name: z.string(),
  merchantId: z.string(),
  status: z.number().nullable(),
})

export type BankAccount = z.infer<typeof BankAccountSchema>
export type PaginatedProgramBankAccountsList = z.infer<
  typeof PaginatedProgramBankAccountsListSchema
>
export type Processor = z.infer<typeof ProcessorSchema>
export type UpdateBankAccountRequest = z.infer<
  typeof updateBankAccountRequestSchema
>
